import React from "react";
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import AnalyticsHeader from "visual-components/analyticsDashboard/analytics-header";
import SocialClicksTooltip from "visual-components/analyticsDashboard/tooltip/SocialClicksTooltip";
import GraphEmptyState from "visual-components/util/graphs/empty-state";
import LabeledBarChart from "./LabeledBarChart";

/**
 * Click Contribution Card Component
 * Displays Custom CTA clicks contribution by partner
 * @param {Object} props
 * @param {string} props.totalPretty - Formatted total clicks
 * @param {Array} props.data - Contribution data
 * @param {boolean} props.started - Whether chart should render
 * @param {Array<{value: string, label: string}>} [props.options] - Dropdown options
 * @param {string} [props.value] - Selected dropdown value
 * @param {Function} [props.onChange] - Dropdown change handler
 * @param {boolean} [props.isHost] - Whether current user is host
 * @returns {import("react").ReactElement}
 */
export default function ClickContributionCard(props) {
  const { totalPretty, options, value, onChange, data, started } = props;

  return (
    <Card sx={{ height: 500 }}>
      <CardHeader
        title={
          <AnalyticsHeader
            title="Custom CTA"
            tooltipText="The number of Custom CTA clicks driven by each partner"
            showSelect
            selectProps={{ value, options, onChange }}
          />
        }
      />
      <CardContent>
        {totalPretty && totalPretty !== "0" ? (
          <>
            <Box>
              <Typography variant="h5" component="span" sx={{ fontWeight: "bold" }}>
                {totalPretty}
              </Typography>
              <Typography variant="h6" component="span" sx={{ ml: 1, color: "text.secondary" }}>
                clicks
              </Typography>
            </Box>
            <LabeledBarChart
              data={data}
              enabled={started}
              labelField="accountname"
              valueField="entries"
              tooltip={(params) => <SocialClicksTooltip {...params} />}
            />
          </>
        ) : (
          <GraphEmptyState
            text="The Custom CTA is a powerful feature reserved for Premium DojoMojo users."
            learnMore="https://help.dojomojo.com/hc/en-us/articles/226204288-Drive-Conversions-and-Page-Views-with-a-Custom-CTA"
            bigText
          />
        )}
      </CardContent>
    </Card>
  );
}
